import appActionTypes from "../constants/types";

export const initialState = {
  data: [],
  isLoading: false,
  message: null,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.product.get.requested:
    case appActionTypes.product.create.requested:
    case appActionTypes.product.delete.requested:
    case appActionTypes.product.edit.requested:
      return {
        ...state,
        isLoading: true,
        message: action.message,
        errorMessage: null
      };
    case appActionTypes.product.get.success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };
      
    case appActionTypes.product.create.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      _list.push(action.data);
      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };

    case appActionTypes.product.delete.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id);
      if (index !== -1) _list.splice(index, 1);

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };
      
    case appActionTypes.product.edit.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id);
      if (index !== -1) _list[index] = action.data;

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };
    case appActionTypes.product.get.fail:
    case appActionTypes.product.create.fail:
    case appActionTypes.product.delete.fail:
    case appActionTypes.product.edit.fail:
      return {
        ...state,
        isLoading: false,
        message: null,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};
